import { useNavigate } from "react-router-dom"
import DynamicButton from "../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"

const CarrierManagement = () => {

  const navigate = useNavigate()

  const tableData = [
    { carrierName: "Pakistan Post", status: "Active" },
    { carrierName: "TCS", status: "Inactive" },
    { carrierName: "DHL", status: "Active" },
    { carrierName: "Pakistan Post", status: "Inactive" },
  ]

  const columns = [
    {
      name: "Carrier Name",
      selector: (row) => row.carrierName,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Actions",
      cell: () => (
        <div className="d-flex gap-2 align-items-center">
          <button style={{ all: "unset" }}>Edit</button>
          <button style={{ all: "unset" }}>View</button>
        </div>
      ),
    },
  ]

  return (
    <LightGrayBgWrapper>

      <div className="fw-semibold fs-5 mb-3">Carrier Management</div>

      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow">
        <div className="fw-semibold fs-5">Shipping Carriers</div>
        <DynamicButton theme="blue" onClick={() => navigate('/shipping-and-delivery/carrier-management/add-carrier')}>
          Add new
        </DynamicButton>
      </div>

      <DynamicDatatable columns={columns} data={tableData} type="yellow" />
    </LightGrayBgWrapper>
  )
}

export default CarrierManagement
